import { AuthorizationCodeTokenClient, OidcUrlHelper } from '@ori/auth';

import { IDENTITY_CLIENT_ID, NodeEnv } from '~/constants';

export const TOKEN_STATE_PARAM = 'state';

/**
 * Extracts token from URL only on dev machine. Not needed elsewhere.
 */
export const optionallyGetTokenFromUrl = async (identityUrl: string) => {
  if (process.env.NODE_ENV !== NodeEnv.Production) {
    const searchParams = new URLSearchParams(window.location.hash.split('?')[1]);
    if (searchParams.has('state')) {
      const oidcUrlHelper = new OidcUrlHelper();
      const tokenClient = new AuthorizationCodeTokenClient({
        clientId: IDENTITY_CLIENT_ID,
        identityUrl,
      });
      oidcUrlHelper.storeAuthCodeFromParams(searchParams);
      await tokenClient.initializeTokenFromAuthorizationCode();
      oidcUrlHelper.handleRedirectAfterLogin();
    }
  }
};
